(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('warnings-list', {
                parent: 'dashboard',
                url: '/warnings-list?id&search&page&sort',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.warning.dashboard.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warnings-list/warnings-list.html',
                        controller: 'WarningsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {

                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    filter: {
                        value: {
                            status: 'open',
                            objectsStatus: 'all',
                            wipStatus: 'all',
                            fleets: [],
                            categories: [],
                            warningNames: []
                        },
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            filter: $stateParams.filter,
                            search: $stateParams.search,
                            predicates: $stateParams.predicates,
                            fleets: $stateParams.fleets,
                            warningName: $stateParams.warningName,
                            category: $stateParams.category
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('myDomainNotification');
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MyDomainNotification', function($stateParams, MyDomainNotification) {
                        if($stateParams.id != null || $stateParams.id != undefined) {
                            return MyDomainNotification.getOne({id: $stateParams.id});
                        }
                        return null;
                    }]
                }
            })
            .state('warnings-list-detail', {
                parent: 'warnings-list',
                url: '/detail/{name}/{objectUniqueCode}/{fleet}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER']
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/warnings-list/warnings-list-detail.html',
                        controller: 'WarningsListDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    filter: {
                        value: {
                            status: 'open',
                            objectsStatus: 'all',
                            wipStatus: 'all',
                            fleets: [],
                            categories: [],
                            warningNames: [],
                            name: '',
                            objectUniqueCode: '',
                            fleet: ''
                        },
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            filter: $stateParams.filter,
                            search: $stateParams.search,
                            predicates: $stateParams.predicates,
                            fleets: $stateParams.fleets,
                            warningName: $stateParams.warningName,
                            category: $stateParams.category,
                            name: $stateParams.name,
                            objectUniqueCode: $stateParams.objectUniqueCode,
                            fleet: $stateParams.fleet
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabObjects');
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    warName: ['$stateParams', function ($stateParams) {
                        return $stateParams.name;
                    }],
                    objUniqueCode: ['$stateParams', function ($stateParams) {
                        return $stateParams.objectUniqueCode;
                    }],
                    fleetName: ['$stateParams', function ($stateParams) {
                        return $stateParams.fleet;
                    }]
                }
            });
    }
})();
